import { tokens, typographyStyles } from '@fluentui/react-theme';
import { HighContrastSelectorBlack } from '../../../utilities/index';
import { makeStyles, mergeClasses } from '@griffel/react';
/**
 * @internal
 */ export const donutPieClassNames = {
    root: 'fui-donut-pie__root',
    insideDonutString: 'fui-donut-pie__insideDonutString'
};
/**
 * Base Styles
 */ const useStyles = makeStyles({
    root: {},
    insideDonutString: {
        ...typographyStyles.title2,
        fill: tokens.colorNeutralForeground1,
        [HighContrastSelectorBlack]: {
            fill: 'rgb(179, 179, 179)'
        }
    }
});
/**
 * Apply styling to the Pie inside donut chart component
 */ export const usePieStyles_unstable = (props)=>{
    var _props_styles, _props_styles1;
    const { className } = props;
    const baseStyles = useStyles();
    return {
        root: mergeClasses(donutPieClassNames.root, baseStyles.root, className, (_props_styles = props.styles) === null || _props_styles === void 0 ? void 0 : _props_styles.root),
        insideDonutString: mergeClasses(donutPieClassNames.insideDonutString, baseStyles.insideDonutString, className, (_props_styles1 = props.styles) === null || _props_styles1 === void 0 ? void 0 : _props_styles1.insideDonutString)
    };
};
